import { Col, Form, Input, Radio, Row } from "antd";
import styles from "./index.module.less";
import CitySelector from "../CitySelector";
import InputBox from "../InputBox";
import { useEffect, useState } from "react";
import modalCloseIcon from "@/assets/imgs/modal_close.svg";
import classNames from "classnames";
import message from "@/plugins/message";
import SMSCodeBtn from "../SMSCodeBtn";
import { useWatch } from "antd/es/form/Form";
import { isMobile, uuid4V1 } from "@/utils";

const validateFn = (key: string, value: any) => {
  if (key === "company" || key === "phone" || key === "name") {
    return value ? "" : `请输入您的${key}`;
  }
  if (key === "email") {
    return value && !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)
      ? "请输入正确的邮箱地址"
      : "";
  }
  return "";
};
const FormLabel = ({
  label,
  required,
}: {
  label: string;
  required?: boolean;
}) => {
  return (
    <div className={styles.label}>
      {label}
      {required && <span>*</span>}
    </div>
  );
};
const ContactMain = ({
  onClose,
}: {
  onClose?: () => void;
}) => {
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [loading, setLoading] = useState(false);
  const phone = useWatch("phone", form);
  const [showSmsBtn, setShowSmsBtn] = useState(false);  
  useEffect(() => {
    // 判断是电话还是邮箱
    const isPhone = /^1[3-9]\d{9}$/.test(phone);
    const isEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(phone);
    setShowSmsBtn(isPhone);
    if (!phone) {
      setShowSmsBtn(false);
    }
  }, [phone])
  const handleSubmit = async () => {
    if (loading) return; // 防止重复提交
    setErrors({});
    form
      .validateFields()
      .then(async (values) => {
        // 判断是电话还是邮箱
        const isPhone = /^1[3-9]\d{9}$/.test(values.phone);
        const isEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(values.phone);
        if (!isPhone && !isEmail) {
          message.warning("请输入正确的电话或邮箱");
          return;
        }
        setLoading(true);
        console.log("Form values:", values);
        // Handle form submission logic here
        const data = {
          enterpriseType: values.enterpriseType,
          enterpriseName: values.company,
          clientPhone: isPhone ? values.phone : "",
          validCode: values.code,
          clientEmail: isEmail ? values.phone : `${uuid4V1()}@mock.email`,
          province: values.city?.[0],
          city: values.city?.[1],
          clientName: values.name,
          source: "xiaobing",
          procurementReason: values.demand,
        };
        // 判断环境
        const isProd = process.env.PROJECT_ENV === "prod";
        const res = await fetch(
          `https://aibeings-staff${isProd ? "" : "-int"}.xiaoice.com/api/info`,
          {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (!res.ok) {
          message.warning("网络异常，请稍后再试");
          setLoading(false);
          return;
        }
        const result = await res.json();
        if (result.code !== 200) {
          message.warning(result.message || "提交失败，请稍后再试");
          setLoading(false);
          return;
        }
        // 提交成功
        message.success("感谢您的提交，我们会尽快与您联系！");
        onClose?.();
        setLoading(false);
      })
      .catch((errorInfo) => {
        const errorFields = errorInfo.errorFields.reduce(
          (acc: { [key: string]: string }, field: any) => {
            acc[field.name[0]] = field.errors[0];
            return acc;
          },
          {}
        );
        setErrors(errorFields);
        setLoading(false);
      });
  };
  const [closing, setClosing] = useState(false);
  return (
    <div className={styles.contactMain}>
        <div className={styles.header}>
          <div className={styles.title}>{"联系我们"}</div>
          {onClose && <div className={styles.close} onClick={onClose}>
            <img src={modalCloseIcon} />
          </div>}
        </div>
        <div className={styles.content}>
          <Form
            form={form}
            layout="vertical"
            className={styles.form}
            requiredMark={false}
            onValuesChange={(value, allValues) => {
              const key = Object.keys(value)[0];
              setErrors({
                ...errors,
                [key]: validateFn(key, value[key]),
              });
            }}
          >
            <Form.Item
              label={<FormLabel label="企业类型" required />}
              style={{ marginBottom: 0 }}
              name="enterpriseType"
              initialValue={"达人"}
            >
              <Radio.Group
                options={[
                  {
                    value: "达人",
                    label: "达人",
                  },
                  {
                    value: "个体工商户",
                    label: "个体工商户",
                  },
                  {
                    value: "小微企业（注册资金100万以内）",
                    label: "小微企业（注册资金100万以内）",
                  },
                  {
                    value: "中型企业（注册资金100万至2000万）",
                    label: "中型企业（注册资金100万至2000万）",
                  },
                  {
                    value: "大型企业（注册资金2000万以上）",
                    label: "大型企业（注册资金2000万以上）",
                  },
                ]}
              />
            </Form.Item>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={<FormLabel label="姓名" required />}>
                  <InputBox
                    name="name"
                    rules={[{ required: true, message: "请输入您的姓名" }]}
                    error={!!errors.name}
                  >
                    <Input placeholder="请输入您的姓名" autoComplete="off" />
                  </InputBox>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={<FormLabel label="企业名称" required />}>
                  <InputBox
                    name="company"
                    rules={[{ required: true, message: "请输入您的企业名称" }]}
                    error={!!errors.company}
                  >
                    <Input
                      placeholder="请输入您的企业名称"
                      autoComplete="off"
                    />
                  </InputBox>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={showSmsBtn ? 12 : 24}>
                <Form.Item label={<FormLabel label="联系方式" required />}>
                  <InputBox
                    name="phone"
                    rules={[{ required: true, message: "请输入您的电话或邮箱" }]}
                    error={!!errors.phone}
                  >
                    <Input placeholder="请输入您的电话或邮箱" autoComplete="off" />
                  </InputBox>
                </Form.Item>
              </Col>
              {showSmsBtn && <Col span={12}>
                <Form.Item label={<FormLabel label="验证码" required />}>
                  <InputBox
                    name="code"
                    rules={[{ required: true, message: "请输入您的验证码" }]}
                    error={!!errors.code}
                  >
                    <Input placeholder="请输入您的验证码" autoComplete="off" />
                  </InputBox>
                  <div className={styles.smsCode}>
                    <SMSCodeBtn phone={form.getFieldValue("phone")} />
                  </div>
                </Form.Item>
              </Col>}
            </Row>
            <Row gutter={16}>

              <Col span={24}>
                <Form.Item label={<FormLabel label="您的城市" required />} name="city" rules={[{
                  required: true, message: "请选择您的城市",
                }]}>
                  <InputBox name="city">
                    <CitySelector />
                  </InputBox>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item
              label={<FormLabel label="您的需求或您感兴趣的产品" />}
              name="demand"
              style={{ marginBottom: 0 }}
            >
              <InputBox name="demand">
                <Input.TextArea placeholder="请输入您的需求或您感兴趣的产品" />
              </InputBox>
            </Form.Item>
          </Form>
        </div>
        <div className={styles.footer}>
          <div className={styles.submitBtn} onClick={handleSubmit}>
            {loading ? "提交中..." : "提交"}
          </div>
        </div>
    </div>
  );
};

export default ContactMain;
